import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Followup = ({ show, onClose, selectedId, refresh, count, name, mobile, email }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    
    const [appointmentdate, setDate] = useState(null);
    const handleDateChange = (dateValue) => {
        // Format the selected date to 'YYYY-MM-DD' and store it in the state
        if (dateValue) {
          const formattedDate = dateValue.format('YYYY-MM-DD');
          setDate(formattedDate);
        } else {
          setDate(null);
        }
    };

    const [appointmenttime, setTime] = useState(null);
    const handleTimeChange = (timeValue) => {
        if (timeValue) {
            // Format the selected time to 'H:i' (24-hour format)
            const formattedTime = timeValue.format('HH:mm');
            setTime(formattedTime);
        } else {
            setTime(null); // If no time is selected, set time as null
        }
    };

    const [comments, setcomments] = useState(null);

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        if (!appointmentdate) {
            newErrors.date = "This Field is Required.";
        }
        
        if (!appointmenttime) {
            newErrors.time = "This Field is Required.";
        }

        if(!comments){
            newErrors.comments = "This Field is Required.";
        }

        return newErrors;
    };
    
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const handleSubmit = (event) => {
        event.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { 
            lead: selectedId,
            appointment_date: appointmentdate,
            appointment_time: appointmenttime,
            comments: comments,
            score: null,
            progress: null,
            created_by: user_id,
            branch_id: branch_id
         };
        axios.post(`${baseURL}/leadfollowup`, postData)
            .then(response => {
                onClose();
                refresh();
                count();
                toast.success("Followup Scheduled Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Followup Schedule Failed");
            });
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Followup Schedule</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className='col-lg-12 mb-3'>
                                <div className="row">
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                        <label className='text-gray-800 font-w500 fs-7'>Lead</label>
                                        <label className='text-black fs-6 font-w500'>{name}</label>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                        <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                                        <label className='text-black fs-6 font-w500'>{mobile}</label>
                                    </div>
                                    <div className='col-lg-12 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                        <label className='text-gray-800 font-w500 fs-7'>Email ID</label>
                                        <label className='text-black fs-6 font-w500'>{email ? email : '-'}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Followup Date<span className="required">*</span></label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker placeholder='Select Date'
                                        onChange={handleDateChange}
                                        format="DD-MM-YYYY"
                                        minDate={new Date(new Date().setHours(0, 0, 0, 0))}
                                    />
                                </div>
                                {errors.date && <div className="text-danger fs-8 mt-1">{errors.date}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Followup Time<span className="required">*</span></label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'>
                                        <i className='fa-solid fa-clock fs-4'></i>
                                    </div>
                                    <DatePicker placeholder='Select Time'
                                        disableDayPicker
                                        onChange={handleTimeChange}
                                        format="hh : mm A"
                                        showTime={{
                                            format: "hh:mm A", // 12-hour format for display
                                            use12Hours: true, // 12-hour clock
                                        }}
                                        plugins={[
                                            <TimePicker />
                                        ]}
                                    />
                                </div>
                                {errors.time && <div className="text-danger fs-8 mt-1">{errors.time}</div>}
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label className="text-black font-w500 fs-7">Comments<span className="required">*</span></label>
                                <input class="form-control" type="text" placeholder=" Enter Comments.."
                                    maxLength={255}
                                    value={comments} 
                                    onChange={(e) => setcomments(e.target.value)}
                                />
                                {errors.comments && <div className="text-danger fs-8 mt-1">{errors.comments}</div>}
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <button type="submit" className="btn btn-sm btn-primary">Followup Schedule <i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default Followup;
